import { Activity } from '@wilson/interfaces';

export function isActivityStartLocationMismatch(
  id: string,
  activities: Activity[],
): boolean {
  const currentActivityIndex = activities.findIndex(
    (activity) => activity.id === id,
  );

  if (currentActivityIndex <= 0) return false;
  return (
    activities[currentActivityIndex].startLocationId !==
    activities[currentActivityIndex - 1].endLocationId
  );
}
